import AccountCancelPage from './AccountCancelPage'

export default AccountCancelPage
// eslint-disable-next-line import/export
export * from './AccountCancelPage'
